import { ProductMigration } from '../migration-side-nav/product-migration';

export class NetClientMigration implements ProductMigration {
	productName = 'NetClient CS';
	migrationInitiated = false;

	constructor() {}
}
